"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var ImportWeb = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 21 15", fill: "currentColor", width: size || "21", height: size || "15" }, props),
        React.createElement("path", { d: "M15.31 5H1.02v9h15.312c0 .552-.457 1-1.021 1H1.02A1.01 1.01 0 0 1 0 14V1c0-.552.457-1 1.02-1h14.29c.565 0 1.022.448 1.022 1v4.016L15.31 5zm0-1V1H1.02v3h14.29zM2.042 2h1.021v1h-1.02V2zm2.042 0h1.02v1h-1.02V2zm2.041 0h1.021v1h-1.02V2zm13.126 8.01H8.93V8.988h10.135l-2.256-2.34.707-.722 3.456 3.739-.043.044-.029.03-.557.575-.008-.008-2.848 2.855-.615-.655 2.378-2.498z", fillRule: "evenodd" })));
};
ImportWeb.displayName = 'ImportWeb';
exports.default = ImportWeb;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ImportWeb.js.map